// extracted by mini-css-extract-plugin
export default {"continue-as-guest":"buttons_continue-as-guest__kOCYX"};